export const highlightedLivestreamData = [
  {
    "creatorAddress": "0x6D5969f4472e2a1ef14fe5326933f1cf88C015e6",
    "creatorvideo": "https://pbs.twimg.com/profile_videos/1554896370263379968/bu6hsLB8_400x400.jpg",
    "creatorName": "X&ND 💔",
    "video": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmTM3FW5tt2vdUPaUGU9GZaoDJuoqNHx5VK5UHsJma7H2Z.mp4",
    "itemName": "STUDIO 002",
    "itemRoute": "/profile/x&nd"
  },
  {
    "creatorAddress": "0x0105eece5b222acf7a1685d75899f410d1320628",
    "creatorvideo": "https://pbs.twimg.com/profile_videos/1542541226267889665/jNY749F1_400x400.jpg",
    "creatorName": "YahZarah",
    "video": "https://the402.mypinata.cloud/ipfs/QmQaVJvRpP1s9A2jbP7TZp6gz2F5NxdzGM4BUURSA9zNAR",
    "itemName": "Genesis Livestream",
    "itemRoute": "/profile/yahzarah"
  },
  {
    "creatorAddress": "0x7933231775dec3f3c80039debd7e3afd8a81f674",
    "creatorvideo": "https://pbs.twimg.com/profile_banners/3304027585/1652511739/1500x500",
    "creatorName": "UVR",
    "video": "https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmZD5AfQEAjFX5mAxWuDuv8r2LLfT6jTqULXgdgY8Q4uj2.mp4",
    "itemName": "GATED AND UNCUT",
    "itemRoute": "/profile/UVR"
  },
  {
    "creatorAddress": "0x0d910be7bd2a29e812b2156e21651cde64132b18",
    "creatorvideo": "https://the402.mypinata.cloud/ipfs/QmVhoAuX2BCLXSNDAoxh9BFRCBZY38sMKd32ETEnF52Q4y",
    "creatorName": "Joe Rian",
    "video": "https://the402.mypinata.cloud/ipfs/QmeZmx3HgzxYKgNuToTm7TgBdyuo9teKVgv3r6qFYvTUBM",
    "itemName": "Livestream 001",
    "itemRoute": "/profile/joerian"
  },
];
